import { shape, symbol } from 'prop-types'

export const component = shape({ $$typeof: symbol })
